import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});

export default function SDM17DEC(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'FHEPOOL__FHEPRODUCT_SET_SDM17DECS':
            return core.setSDM17DECs(state, action.SDM17DECs);
        case 'FHEPOOL__FHEPRODUCT_UPDATE_SDM17DECS':
            return core.updateSDM17DECs(state, action.SDM17DECs);
        case 'FHEPOOL__FHEPRODUCT_SET_SDM17DEC_DETAILS':
            return core.setSDM17DECDetails(state, action.SDM17DECId, action.SDM17DECDetails, action.SDM17DECLines);
        case 'FHEPOOL__FHEPRODUCT_UPDATE_SDM17DEC_STATUS':
            return core.updateSDM17DECStatus(state, action.productIdentifier, action.status);
        case 'FHEPOOL__FHEPRODUCT_MASTER_SWITCH_SDM17DEC':
            return core.switchSDM17DECMaster(state, action.productIdentifier, action.masterId);
        case 'FHEPOOL__FHEPRODUCT_DISSOCIATE_USER_SDM17DEC':
            return core.dissociateUserFromSDM17DEC(state, action.productIdentifier, action.userId);
        case 'FHEPOOL__FHEPRODUCT_DISSOCIATE_USER_AND_SWITCH_MASTER_SDM17DEC':
            return core.dissociateUserFromSDM17DECAndSwitchMaster(state, action.productIdentifier, action.userId, action.masterId);
    }

    return state;
}



// WEBPACK FOOTER //
// ./environments/fhepool/data/SDM17DEC/reducer.js